/* Wicked Prop — store-wide sections: shop grid filter chips. No dynamic import() here (the asset minifier breaks it). */
(function () {
  function initGrid() {
    document.querySelectorAll('[data-wps-grid]').forEach(function (grid) {
      if (grid._wps) return; grid._wps = true;
      grid.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-wps-filter]');
        if (!chip) return;
        var want = chip.getAttribute('data-wps-filter');
        grid.querySelectorAll('[data-wps-filter]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        grid.querySelectorAll('.wps-card').forEach(function (card) {
          var show = want === 'all' || card.getAttribute('data-wps-type') === want;
          card.hidden = !show;
          if (show) card.classList.add('is-in');
        });
      });
    });
  }
  function pick(grid, want) {
    var chip = grid.querySelector('[data-wps-filter="' + want + '"]'); if (chip) chip.click();
  }
  document.addEventListener('click', function (e) {
    var j = e.target.closest('[data-wps-jump]'); if (!j) return;
    var grid = document.querySelector('[data-wps-grid]'); if (!grid) return;
    e.preventDefault(); pick(grid, j.getAttribute('data-wps-jump'));
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function initDays() {
    document.querySelectorAll('[data-wps-days]').forEach(function (el) {
      var t = new Date(el.getAttribute('data-wps-days') + 'T00:00:00'); if (isNaN(t)) return;
      var n = Math.ceil((t - new Date()) / 86400000); if (n < 1) return;
      var b = el.querySelector('[data-wps-days-n]'); if (b) b.textContent = n; el.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDays); else initDays();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGrid); else initGrid();
  document.addEventListener('shopify:section:load', initGrid);
})();
